
















import Vue from "vue";
import { doubleRaf } from "@/utils/dom";

const PREFIX = "scroll-display";

export default Vue.extend({
  name: "ScrollDisplay",
  props: {
    text: {
      type: Array,
      default: []
    },
    delay: {
      type: Number,
      default: 0
    },
    verticalScrollInterval: {
      type: Number,
      default: 0
    },
    speed: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      prefix: PREFIX,
      offset: 0,
      duration: 0,
      wrapWidth: 0,
      contentWidth: 0,

      count: 0,
      active: 0
    };
  },
  computed: {
    after(): number {
      if (!this.text.length) {
        return 0;
      }
      return (this.active + 1) % this.text.length;
    },
    prepare(): number {
      if (!this.text.length) {
        return 0;
      }
      return (this.active + 2) % this.text.length;
    },
    wrapClass(): object {
      return {
        [`${this.prefix}__wrap`]: true
      };
    },
    contentClass(): object {
      return {
        [`${this.prefix}__content`]: true,
        [`${this.prefix}__content--vertical-interval`]: true
      };
    },
    paragraphStyle(): object {
      return {
        transform: this.offset ? `translateY(${this.offset}px)` : "",
        transitionDuration: this.duration + "s"
      };
    }
  },
  watch: {
    text: {
      // @ts-ignore
      handler: function() {
        this.start();
      },
      immediate: true
    }
  },
  methods: {
    start() {
      const delay = this.delay;
      this.reset();
      setTimeout(() => {
        const { wrap, content } = this.$refs;
        const wrapWidth = (wrap as HTMLDivElement).getBoundingClientRect().height;
        const contentWidth = (content as HTMLDivElement).getBoundingClientRect().height;
        doubleRaf(() => {
          this.offset = -contentWidth;
          this.duration = contentWidth / this.speed;
          this.wrapWidth = wrapWidth;
          this.contentWidth = contentWidth;
        });
      }, delay);
    },
    // 重设
    reset() {
      this.offset = 0;
      this.duration = 0;
      this.wrapWidth = 0;
      this.contentWidth = 0;
    },
    onParagraphTransitionEnd() {
      // 垂直多组段落滚动
      ++this.count; // 记录周期内滚动次数

      // 滚筒为3个槽，及时更换数据
      if (this.count % 2 === 0) {
        this.duration = 0;
        this.offset = 0;
        this.active = (this.active + 2) % this.text.length;

        // 归零（可选）
        if (this.active === 0) {
          this.count = 0;
        }
      }

      setTimeout(() => {
        doubleRaf(() => {
          this.offset = -this.contentWidth + this.offset;
          this.duration = this.wrapWidth / this.speed;
        });
      }, this.verticalScrollInterval);
    }
  }
});
